var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',_vm._l((_vm.projectsList),function(project){return _c('v-col',{key:project.id,attrs:{"cols":"12","md":"6","lg":"4","xl":"3"}},[_c('ProjectCard',{attrs:{"project":project,"deletable":_vm.deletePermitted},on:{"delete":_vm.confirmDeleteProject}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }